import { z } from 'zod';

/** A single feature flag row as returned by the admin feature-flags API. */
export const FeatureFlagAdminItemSchema = z.object({
  key: z.string(),
  description: z.string().nullable(),
  enabled: z.boolean(),
});
export type FeatureFlagAdminItem = z.infer<typeof FeatureFlagAdminItemSchema>;

/** Request body schema for PATCH /admin/feature-flags/:key. */
export const UpdateFeatureFlagBodySchema = z.object({
  enabled: z.boolean(),
});
export type UpdateFeatureFlagBody = z.infer<typeof UpdateFeatureFlagBodySchema>;
